/**
 * Every PostHog flag key the apps read, split by kind because the three read differently: a boolean
 * is `flag()`, a multivariate arm is `flag()` with a string fallback, and a payload is `config()`.
 *
 * Keys are created in the PostHog project by a human. A key with no flag behind it evaluates to
 * `undefined` and the caller's fallback is used, so an entry here is safe before the flag exists.
 */
export const PostHogBooleanFlag = {
  /**
   * No surface and no product meaning. It exists so the SSR bootstrap can be proven end to end:
   * the server evaluates it, `TransferState` carries it, the browser bootstraps from it, and the
   * read fires one exposure.
   */
  PublicSsrFlagCanary: 'public-ssr-flag-canary',
} as const;

export const PostHogVariantFlag = {
  /** Splits the seller flow between today's screens and the redesign at the same URLs. */
  SellerFlowRedesign: 'seller-flow-redesign',
} as const;

export type PostHogBooleanFlagKey = (typeof PostHogBooleanFlag)[keyof typeof PostHogBooleanFlag];
export type PostHogVariantFlagKey = (typeof PostHogVariantFlag)[keyof typeof PostHogVariantFlag];
export type PostHogFlagKey = PostHogBooleanFlagKey | PostHogVariantFlagKey;
